module.exports = __webpack_public_path__ + "img/12.0252bfd3.jpg";